import styles from './PageHeaderRow.module.scss';

export interface IPageHeaderRowProps {
    children: any;
}

export function PageHeaderRow(props: IPageHeaderRowProps) {
    return (<div className={styles.host}>{props.children}</div>);
}
